import React from "react";
import PropTypes from "kf-proptypes/widgets";
import { Collapse as AntCollapse } from "antd";

import "antd/es/collapse/style/css";

import styles from "./accordian.css";

import RightArrowIcon from "./RightArrow.svg";
import LeftArrowIcon from "./LeftArrow.svg";
import DownArrowIcon from "./DownArrow.svg";

const { Panel: AntCollapsePanel } = AntCollapse;

export const ICON_POSITION = {
  RIGHT: "right",
  LEFT: "left"
};

export function Accordian(props) {
  const {
    children,
    onChange,
    className,
    activePanelIndexes = [],
    isCollapse = true,
    expandIconPosition = ICON_POSITION.RIGHT,
    expandIconRenderer
  } = props;
  return (
    <AntCollapse
      defaultActiveKey={activePanelIndexes}
      onChange={onChange}
      expandIconPosition={expandIconPosition}
      accordion={isCollapse}
      expandIcon={(panelProps) => {
        if (expandIconRenderer) {
          return expandIconRenderer(panelProps);
        }
        if (!panelProps.isActive) {
          return window.isRTL ? <LeftArrowIcon /> : <RightArrowIcon />;
        }
        return <DownArrowIcon />;
      }}
      className={`${styles.accordion} ${className}`}
      {...props}
    >
      {children}
    </AntCollapse>
  );
}

Accordian.propTypes = {
  children: PropTypes.node.isRequired,
  /** Additional class to pass to accordian */
  className: PropTypes.string,
  /** Called when ever switching the Pannel  */
  onChange: PropTypes.func.isRequired,
  /** Takes List of Indexes of Pannel which will stay open at mount */
  activePanelIndexes: PropTypes.arrayOf(PropTypes.number),
  /** key of pannel to open */
  activeKey: PropTypes.arrayOf(PropTypes.number),
  /** When set to true, only one pannel can be openned at a time */
  isCollapse: PropTypes.bool,
  /** Position at which the pannel icons needs to displayed */
  expandIconPosition: PropTypes.oneOf(Object.values(ICON_POSITION)),
  /** Renders given icon */
  expandIconRenderer: PropTypes.func
};

Accordian.defaultProps = {
  expandIconPosition: ICON_POSITION.RIGHT
};

// eslint-disable-next-line kf/const-naming-convention
export const AccordianPanel = AntCollapsePanel;
AccordianPanel.displayName = "AccordianPanel";
AccordianPanel.propTypes = {
  header: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired
  // activePanelIndexes: PropTypes.arrayOf(PropTypes.number)
};
